<template>
    <div class="blocked-gallery">
        <div class="blocked-gallery__frame">
            <div class="blocked-gallery__stage">
                <img
                    v-if="currentSlide"
                    :key="currentSlide.src"
                    :src="currentSlide.src"
                    :alt="currentSlide.alt"
                    class="blocked-gallery__image"
                    @click="openLightbox"
                />
            </div>

            <button
                v-if="total > 1"
                type="button"
                class="blocked-gallery__nav blocked-gallery__nav_prev"
                aria-label="Предыдущий"
                @click="goPrev"
            >‹</button>
            <button
                v-if="total > 1"
                type="button"
                class="blocked-gallery__nav blocked-gallery__nav_next"
                aria-label="Следующий"
                @click="goNext"
            >›</button>
        </div>

        <div
            v-if="total > 1"
            class="blocked-gallery__counter"
        >
            Шаг {{ currentIndex + 1 }} / {{ total }}
        </div>
        <p
            v-if="currentSlide"
            class="blocked-gallery__caption"
        >
            {{ currentSlide.caption }}
        </p>

        <div
            v-if="lightboxOpen && currentSlide"
            class="blocked-gallery__lightbox"
            @click="onOverlayClick"
        >
            <button
                type="button"
                class="blocked-gallery__lightbox-close"
                aria-label="Закрыть"
                @click="closeLightbox"
            >×</button>
            <button
                v-if="total > 1"
                type="button"
                class="blocked-gallery__lightbox-nav blocked-gallery__lightbox-nav_prev"
                aria-label="Предыдущий"
                @click.stop="goPrev"
            >‹</button>
            <button
                v-if="total > 1"
                type="button"
                class="blocked-gallery__lightbox-nav blocked-gallery__lightbox-nav_next"
                aria-label="Следующий"
                @click.stop="goNext"
            >›</button>
            <img
                :key="currentSlide.src"
                :src="currentSlide.src"
                :alt="currentSlide.alt"
                class="blocked-gallery__lightbox-image"
                @click.stop
            />
            <p class="blocked-gallery__lightbox-caption">
                {{ currentSlide.caption }}
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'BlockedGallery',
        props: {
            slides: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                currentIndex: 0,
                lightboxOpen: false,
            };
        },
        computed: {
            total() {
                return this.slides.length;
            },
            currentSlide() {
                return this.slides[this.currentIndex];
            },
        },
        mounted() {
            document.addEventListener('keydown', this.onKeydown);
        },
        beforeDestroy() {
            document.removeEventListener('keydown', this.onKeydown);
            document.body.style.overflow = '';
        },
        methods: {
            goPrev() {
                if (!this.total) return;
                this.currentIndex = (this.currentIndex - 1 + this.total) % this.total;
            },
            goNext() {
                if (!this.total) return;
                this.currentIndex = (this.currentIndex + 1) % this.total;
            },
            openLightbox() {
                this.lightboxOpen = true;
                document.body.style.overflow = 'hidden';
            },
            closeLightbox() {
                this.lightboxOpen = false;
                document.body.style.overflow = '';
            },
            onOverlayClick(event) {
                if (event.target === event.currentTarget) {
                    this.closeLightbox();
                }
            },
            onKeydown(event) {
                if (event.key === 'ArrowLeft') {
                    this.goPrev();
                } else if (event.key === 'ArrowRight') {
                    this.goNext();
                } else if (event.key === 'Escape' && this.lightboxOpen) {
                    this.closeLightbox();
                }
            },
        },
    };
</script>

<style
    scoped
    lang="scss"
>
    @import "../../scss/base/colors";

    .blocked-gallery {
        margin-top: 16px;

        &__frame {
            position: relative;
            background: #F0F2FB;
            border: 1px solid rgba(96, 137, 231, 0.2);
            border-radius: 8px;
            overflow: hidden;
        }

        &__stage {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 14px;
        }

        &__image {
            max-height: 360px;
            max-width: 100%;
            width: auto;
            object-fit: contain;
            border-radius: 6px;
            cursor: zoom-in;
        }

        &__nav {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            width: 34px;
            height: 34px;
            border-radius: 50%;
            border: 1px solid rgba(96, 137, 231, 0.25);
            background: #FFFFFF;
            color: $dark-blue-color;
            font-size: 22px;
            line-height: 1;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 2px 6px 0 rgba(174, 191, 241, 0.7);

            &:hover {
                background: #F0F2FB;
            }

            &_prev { left: 10px; }
            &_next { right: 10px; }
        }

        &__counter {
            margin-top: 12px;
            text-align: center;
            font-size: 11px;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 0.06em;
            color: #6F6F70;
        }

        &__caption {
            margin: 4px 0 0;
            text-align: center;
            font-size: 13px;
            line-height: 18px;
            color: #3F3F40;
        }

        &__lightbox {
            position: fixed;
            inset: 0;
            z-index: 1000;
            background: rgba(0, 0, 0, 0.8);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 24px;
        }

        &__lightbox-image {
            max-height: 90vh;
            max-width: 90vw;
            object-fit: contain;
            border-radius: 8px;
            box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
        }

        &__lightbox-caption {
            margin: 16px 0 0;
            text-align: center;
            font-size: 14px;
            color: rgba(255, 255, 255, 0.9);
            max-width: 720px;
        }

        &__lightbox-close {
            position: absolute;
            top: 16px;
            right: 16px;
            width: 38px;
            height: 38px;
            border-radius: 50%;
            border: none;
            background: rgba(255, 255, 255, 0.12);
            color: #FFFFFF;
            font-size: 24px;
            line-height: 1;
            cursor: pointer;

            &:hover { background: rgba(255, 255, 255, 0.22); }
        }

        &__lightbox-nav {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            width: 40px;
            height: 40px;
            border-radius: 50%;
            border: none;
            background: rgba(255, 255, 255, 0.12);
            color: #FFFFFF;
            font-size: 26px;
            line-height: 1;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;

            &:hover { background: rgba(255, 255, 255, 0.22); }

            &_prev { left: 16px; }
            &_next { right: 16px; }
        }
    }
</style>
